import React, { lazy, Suspense } from 'react';

// imports of Components
const Hero = lazy(() => import('mui/components/sections/HeroSection'));
const SuccessStories = lazy(() => import('components/SuccessStories'));
const TextWithTwoImages = lazy(() => import('components/TextWithTwoImages'));
const Reviews = lazy(() => import('components/Reviews'));
const ResponsiveImage = lazy(() => import('components/ResponsiveImage'));
const PriceComparison = lazy(() => import('components/PriceComparison'));
const TextWithBeforeAfter = lazy(() => import('components/TextWithBeforeAfter'));
const Info = lazy(() => import('mui/components/sections/Info'));
const TextImageRows = lazy(() => import('components/TextImageRows'));
const LocationsList = lazy(() => import('components/LocationsList'));
const CustomContent = lazy(() => import('mui/components/sections/DS_CustomContent'));
const RegisterForm = lazy(() => import('mui/components/sections/RegisterForm'));
const Trustpilot = lazy(() => import('components/Trustpilot'));
const DS_BasicHero = lazy(() => import('mui/components/sections/DS_BasicHero'));
const DS_Hero = lazy(() => import('mui/components/sections/DS_Hero'));
const DS_Prices = lazy(() => import('mui/components/sections/DS_Prices'));
const DS_Steps = lazy(() => import('mui/components/sections/DS_Steps'));
const DS_TrustFacts = lazy(() => import('mui/components/sections/DS_TrustFacts'));
const DS_Problems = lazy(() => import('mui/components/sections/DS_Problems'));
const DS_Benefits = lazy(() => import('mui/components/sections/DS_Benefits'));
const DS_Testimonials = lazy(() => import('mui/components/sections/DS_Testimonials'));
const DS_Faq = lazy(() => import('mui/components/sections/DS_Faq'));
const DS_LocationsCards = lazy(() => import('mui/components/sections/DS_LocationsCards'));
const DS_HowItWorks = lazy(() => import('mui/components/sections/DS_HowItWorks'));
const DS_Advantages = lazy(() => import('mui/components/sections/DS_Advantages'));
const DS_PriceHero = lazy(() => import('mui/components/sections/DS_PriceHero'));
const DS_FindInMap = lazy(() => import('mui/components/sections/DS_FindInMap'));
const DS_TextWithImage = lazy(() => import('mui/components/sections/DS_TextWithImage'));
const DS_Banner = lazy(() => import('mui/components/sections/DS_Banner'));
const DS_Bundles = lazy(() => import('mui/components/sections/DS_Bundles'));
const DS_Timeline = lazy(() => import('mui/components/sections/DS_Timeline'));
const DS_TimelineSteps = lazy(() => import('mui/components/sections/DS_TimelineSteps'));
const DS_TimelineVideo = lazy(() => import('mui/components/sections/DS_TimelineVideo'));
const DS_Features = lazy(() => import('mui/components/sections/DS_Features'));
const DS_TwoImgsBenefits = lazy(() => import('mui/components/sections/DS_TwoImgsBenefits'));
const DS_CurrentStep = lazy(() => import('mui/components/sections/DS_CurrentStep'));
const DS_HeroCard = lazy(() => import('mui/components/sections/DS_HeroCard'));
const DS_TwoProductOptions = lazy(() => import('mui/components/sections/DS_TwoProductOptions'));
const DS_InfoGraphics = lazy(() => import('mui/components/sections/DS_InfoGraphics'));
const DS_Interim = lazy(() => import('mui/components/sections/DS_Interim'));
const DSKnownFrom = lazy(() => import('mui/components/sections/DS_KnownFrom'));

const ComponentNotFound = ({ __typename }) => (
  <h3>
    Component <strong style={{ color: 'red' }}>{__typename}</strong> Not Found
  </h3>
);

const body = {
  ContentfulComponentHero: Hero,
  ContentfulComponentResponsiveImage: ResponsiveImage,
  ContentfulComponentSuccessStories: SuccessStories,
  ContentfulComponentTextWithTwoImages: TextWithTwoImages,
  ContentfulComponentReviews: Reviews,
  ContentfulComponentPriceComparison: PriceComparison,
  ContentfulComponentTextWithBeforeAfter: TextWithBeforeAfter,
  ContentfulComponentInfo: Info,
  ContentfulComponentTextImageRows: TextImageRows,
  ContentfulComponentLocationsList: LocationsList,
  ContentfulComponentCustomContent: CustomContent,
  ContentfulComponentRegisterForm: RegisterForm,
  ContentfulComponentTrustpilot: Trustpilot,
  ContentfulComponentDsBasicHero: DS_BasicHero,
  ContentfulComponentDsHero: DS_Hero,
  ContentfulComponentDsPrices: DS_Prices,
  ContentfulComponentDsTrustFacts: DS_TrustFacts,
  ContentfulComponentDsSteps: DS_Steps,
  ContentfulComponentDsProblems: DS_Problems,
  ContentfulComponentDsBenefits: DS_Benefits,
  ContentfulComponentDsTestimonials: DS_Testimonials,
  ContentfulComponentDsFaq: DS_Faq,
  ContentfulComponentDsLocationsCards: DS_LocationsCards,
  ContentfulComponentDsPriceHero: DS_PriceHero,
  ContentfulComponentDsHowItWorks: DS_HowItWorks,
  ContentfulComponentDsFindInMap: DS_FindInMap,
  ContentfulComponentDsTextWithImage: DS_TextWithImage,
  ContentfulComponentDsAdvantages: DS_Advantages,
  ContentfulComponentDsBundles: DS_Bundles,
  ContentfulComponentDsTimeline: DS_Timeline,
  ContentfulComponentDsTimelineSteps: DS_TimelineSteps,
  ContentfulComponentDsTimelineVideo: DS_TimelineVideo,
  ContentfulComponentDsBanner: DS_Banner,
  ContentfulComponentDsFeatures: DS_Features,
  ContentfulComponentDsTwoImagesAndBenefits: DS_TwoImgsBenefits,
  ContentfulComponentDsCurrentStep: DS_CurrentStep,
  ContentfulComponentDsHeroCard: DS_HeroCard,
  ContentfulComponentDsTwoProductOptions: DS_TwoProductOptions,
  ContentfulComponentDsInterim: DS_Interim,
  ContentfulComponentDsInfoGraphics: DS_InfoGraphics,
  ContentfulComponentDsKnownFrom: DSKnownFrom,
  NotFound: ComponentNotFound,
};

export default props => {
  const SelectedComponent = body[props.__typename] || ComponentNotFound;

  return (
    <Suspense fallback={<div style={{ height: `100px` }} />}>
      <SelectedComponent {...props} />
    </Suspense>
  );
};
